<template>
    <div class="lWrap">
        <page-header
                v-if="!noHeader"
        >
        </page-header>
        <router-view/>
    </div>
</template>
<script>
    export default {
        name: 'App',
        data() {
            return{

            }
        },
        created() {
            this.$store.dispatch('country/setLocale', {});
        },
        computed: {
            noHeader() {
                return this.$route.meta.noHeader ? this.$route.meta.noHeader : false;
            },
        },
        methods: {

        }
    }
</script>
<style lang="scss">
    @import "./assets/scss/index.scss";
</style>
